<template>
    <div id="appRoot">
        <template v-if="!$route.meta.public">
            <v-app id="inspire" class="app">
                <app-drawer class="app--drawer"></app-drawer>
                <app-toolbar class="app--toolbar"></app-toolbar>
                <v-content>
                    <!-- Page Header -->
                    <page-header v-if="$route.meta.breadcrumb"></page-header>
                    <div class="page-wrapper">
                        <router-view></router-view>
                    </div>
                    <!-- App Footer -->
                    <v-footer height="auto" fixed class="light-gray pa-2 app--footer">
                        <span class="caption">
                                <strong>Copyright &copy; {{ new Date().getFullYear() }}
                                        <a href="https://jbsathler.github.io" target="_blank">IdeaCrafter</a>.
                                </strong>
                                <span style="white-space: nowrap;">Todos os direitos reservados.</span>
                        </span>
                        <v-spacer></v-spacer>
                        <span class="caption mr-1"> v1.0.0 </span>
                    </v-footer>
                </v-content>
                <!-- Go to top -->
                <app-fab></app-fab>
            </v-app>
        </template>
        <template v-else>
            <transition>
                <keep-alive>
                    <router-view :key="$route.fullpath"></router-view>
                </keep-alive>
            </transition>
        </template>
        <v-snackbar
            :timeout="3000"
            bottom
            right
            :color="snackbar.color"
            v-model="snackbar.show"
        >
            {{ snackbar.text }}
            <v-btn dark flat @click.native="snackbar.show = false" icon>
                <v-icon>close</v-icon>
            </v-btn>
        </v-snackbar>
    </div>
</template>
<script>
    import Util         from '@/util';
    import { userKey  } from '@/global';
    import { mapState } from 'vuex';
    import AppDrawer    from '@/components/AppDrawer';
    import AppToolbar   from '@/components/AppToolbar';
    import AppFab       from '@/components/AppFab';
    import PageHeader   from '@/components/PageHeader';
    import AppEvents    from './event';

    export default {
        name       : 'App',
        components : {
            AppDrawer,
            AppToolbar,
            AppFab,
            PageHeader
        },
        data       : () => ({
            expanded        : true,
            rightDrawer     : false,
            validatingToken : true,
            snackbar        : {
                show  : false,
                text  : '',
                color : '',
            }
        }),
        created () {
            AppEvents.forEach(item => {
                this.$on(item.name, item.callback);
            });
            window.getApp = this;
        },
        mounted() {
            this.validateToken();
        },
        computed   : {
            ...mapState(['user']),
            isAdmin() {
                return this.user.perfis.some(perfil => perfil === 'Administrador');
            },
            networkStatus () {
                return this.isOnline ? 'My network is fine' : 'I am offline'
            }
        },
        methods    : {
            async validateToken() {
                this.validatingToken = true;

                const json       = localStorage.getItem(userKey);
                const userData   = JSON.parse(json);
                // console.log('userData', userData);

                this.$store.commit('setUser', {
                    perfis: []
                });

                if (!userData) {
                    this.validatingToken = false;
                    this.$router.push({ path : '/login' });
                    return;
                }

                if (this.isOnline) {
                    const jwtPayload = Util.parseJwt(userData.accessToken);
                    // console.log('jwtPayload', jwtPayload);

                    // TODO: Implementar validação de token no backend
                    // const res = await this.$axios.post('validateToken', userData).catch(err => {
                    //     console.log(err);
                    //     this.validatingToken = false;
                    //     this.$router.push({ path : '/login' });
                    //     return {};
                    // });

                    const expDate = new Date(jwtPayload.exp);
                    // const iatDate = new Date(jwtPayload.iat);
                    const now     = new Date();
                    // console.log({now, expDate, iatDate});

                    if (!jwtPayload.exp || expDate > now) {
                        this.$store.commit('setUser', userData);
                    } else {
                        localStorage.removeItem(userKey);
                        this.$router.push({ path : '/login' });
                    }
                } else {
                    this.$store.commit('setUser', userData);
                }

                this.validatingToken = false;
            }
        }
    };
</script>


<style lang="stylus" scoped>
    .setting-fab
        top:50%!important;
        right:0;
        border-radius:0
    .page-wrapper
        min-height:calc(100vh - 64px - 50px - 81px );
</style>
